import { default as InvoicePlate } from 'kts-invoice-plate/InvoicePlate';
import { default as VehicleInvoicePlate } from 'kts-invoice-plate/VehicleInvoicePlate';
import { default as UsedCarInvoicePlate } from 'kts-invoice-plate/UsedCarInvoicePlate';
import { default as RollTypeInvoicePlate } from 'kts-invoice-plate/RollTypeInvoicePlate';
import { InvoiceDetailedTable, InvoiceDetailedTableVirtualized } from 'kts-invoice-plate/InvoiceDetailedTable';
import { default as ElectricPlate } from 'kts-invoice-plate/ElectricPlate';
import { default as PaymentPlate } from 'kts-invoice-plate/PaymentPlate';
export { InvoicePlate, InvoiceDetailedTable, InvoiceDetailedTableVirtualized, PaymentPlate, VehicleInvoicePlate, RollTypeInvoicePlate, UsedCarInvoicePlate, ElectricPlate };



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/index.js
// module id = 4155
// module chunks = 0